<template>
    <div v-resize="onResize">
           
   <v-container>
         <v-card>
            <v-layout class = "mr-5 mt-4">

       <h1 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px"> <v-icon>mdi-map-marker-multiple</v-icon> Pick Up Point List</h1>
        <v-spacer></v-spacer>
      
        <v-spacer></v-spacer>

        <v-btn @click="openDialog()" rounded outlined style="margin-top :15px; margin-right :10px;font-family:Verdana"> 
                        <v-icon>mdi-map-marker-plus </v-icon>
                            Add New Pick Up Point
                       </v-btn>
       
     </v-layout>
       
   <v-container fluid>  
        <v-simple-table dense fixed-header :height="windowSize.y - 170 " style="margin-top :-10px" >
        <thead>
            <tr>
                <th class="text-center" style = "color:black;font-family:Verdana">Point Name </th>
                <th class="text-center" style = "color:black;font-family:Verdana"> InUse </th>
                <th class="text-center" style = "color:black;font-family:Verdana">Action</th>
            </tr>
            </thead>
            <tbody>
               <tr v-for="item in PickUpList" :key="item.PlateNo">
                   <td class="text-center" style = "color:black;font-family:Verdana">{{item.PointName}}</td>
                    <td class="text-center" style = "color:black;font-family:Verdana">{{item.SelectUse}}</td>
                     <!-- <td class="text-center" style = "color:black;font-family:Verdana">{{item.useSpecial}}</td> -->
                     
                      <td class="text-center" style = "color:black;font-family:Verdana">
                        <v-tooltip bottom>
                          <template v-slot:activator= "{on}">

                        <v-btn v-on="on" elevation="0" x-small fab @click="editRec(item)">
                        <v-icon color="grey darken-1">mdi-pencil</v-icon>
                    </v-btn>
                         </template>
                         <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                       <template v-slot:activator= "{on}">
                    <v-btn v-on="on" elevation="0" x-small fab @click="deleteRec(item,item.pickpointID)">
                        <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                    </v-btn>
                    </template>
                      <span>Delete</span>
                    </v-tooltip>
                      </td>
               </tr>
            </tbody>
            </v-simple-table>
        
     </v-container>
     

     <v-dialog v-model = "dialog" persistent width="350px">
      <v-card>
          <v-toolbar dense color="#213c57" dark> <v-icon>mdi-information-outline</v-icon>
           <span style = "font-family: Verdana;font-size:15px; margin-left :5px " > Pick Up Point Information</span>
            <v-spacer></v-spacer>
             <v-btn icon @click = "closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-layout row>
                <v-row>
                    <v-col>
                     
                   <v-text-field v-model="toAdd.PointName" outlined label = "Point Name" dense oninput="this.value = this.value.toUpperCase()" ></v-text-field>
                   
                    <v-select v-model="toAdd.SelectUse" :items = "SelectUse" dense outlined label = "In Use"></v-select>
               
                </v-col>
                </v-row>
              </v-layout>
            <v-layout>
            <v-spacer></v-spacer>

              <v-btn style = "margin-top:-25px" block @click = "addPickUp()" color="success"> {{btnName}} </v-btn>
            </v-layout>
            </v-container>
          </v-card-text>
      </v-card>
     </v-dialog>
     </v-card>
     </v-container>
    </div>
</template>

<script>

// import axios from 'axios'
import api from '../api.js'
// import _ from 'lodash'
import swal from 'sweetalert'
export default {
    components:{
       
    },
    created(){
    this.loadPickUp()
   
    },
    data(){
        return{
          SelectUse :['Yes','No'],
          searchCar : '',
        dialog: false,
        PickUpList:[],
        toAdd:{},
        
        btnName: '',
     
      

        }
    },
    computed:{
      //  filterCarsList(){
      //    return this.timeSchedule.filter( rec => {
      //       return rec.PlateNo.toLowerCase().includes(this.searchCar.toLowerCase()) || rec.Driver === this.searchCar
      //     })
      //  }
    },

    methods: {
      openDialog(){
         this.dialog = true
         this.btnName = 'Add'
       },
       closeDialog(){
         this.dialog = false
         this.toAdd = {}
       },
       addPickUp(){
         if(this.btnName === 'Add'){
           let url = `${this.api}addPickUp`
            api.post(url, this.toAdd).then (res =>{
          // this.employeedata = res.data
         console.log(res.data)
         swal( "New Pick Up Point Added", " " , "success" , {
                timer: 1000,
                button:false
            })
          this.loadPickUp()
         this.closeDialog()
          
        
         }) 
         }else {
           let url = `${this.api}updatePickUp`
            api.put(url, this.toAdd).then (res =>{
          // this.employeedata = res.data
            console.log(res.data)
            swal( "Pick Up Point has been updated", " " , "success" , {
                timer: 1000,
                button:false
            })
            this.loadPickUp()
            this.closeDialog()
        })
         }
        
       },
       loadPickUp(){
          let url =  `${this.api}getPickPoint`
         api.get(url).then( res =>{
        this.PickUpList = res.data
        // this.timeSchedule = _.orderBy(res.data, ['timeSched'], ['ASC'])
      //  console.log(this.employeedata)
      }) 
       },

          editRec(rec){
           
          this.dialog = true
          this.btnName = 'Update'
          this.toAdd = rec
        
      },

      deleteRec(rec,pickpointID) {

        swal({
          title: 'Do you want to delete this Pick Up Point?',
          icon : 'warning',
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons : [ 'No',  'Yes']
            
          }).then( (willApprove)=>{
             if (willApprove) {
               swal( "Pick Up Point has been deleted", " " , "error" , {
                timer: 1000,
                button:false
               })
             const index = this.PickUpList.indexOf(rec)
         
              this.PickUpList.splice(index,1)
              let url = `${this.api}deletePickUp`
              api.post(url,{pickpointID:pickpointID}).then( res => {
              console.log(res.data)
              this.loadPickUp()
              }
              )
             }
          })

       
        
      },




    }
}


</script>

<style scoped>
table,th,td {
  border: 1px solid grey !important;
}
td{
  padding: 3px !important;
}

th{  
    background-color: #213c57 !important;
    color:white !important;
    font-family: Arial !important;
    padding:15px !important;
    font-size:13px;
}
tr:hover {
  background-color: #cdcdd1 !important;
}

</style>


